<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds-from-desktop">
    <h1 class="govuk-heading-l">Page no longer available</h1>
    <p>The page you are trying to view does not exist anymore.</p>
    <p><a [routerLink]="['/login']" class="text-link">Return to the homepage</a></p>
  </div>
</div>
